import { render, staticRenderFns } from "./BoxRoles.vue?vue&type=template&id=57be348b"
import script from "./BoxRoles.vue?vue&type=script&lang=js"
export * from "./BoxRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports